import { Flex, Tooltip, Text } from '@chakra-ui/react'
import React from 'react'

interface IProps {
  cellData: string | undefined
  width: number
  schemaFix: string | undefined
}

function CellDisplay({ cellData, width, schemaFix }: IProps) {
  const changedTextStyle: React.CSSProperties = {
    textDecoration: 'line-through',
    color: 'red',
  }
  if (cellData === schemaFix) {
    return <Text textOverflow="ellipsis">&quot;{schemaFix}&quot;</Text>
  }

  const normalStyle: React.CSSProperties = {
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }

  return (
    <Tooltip
      bgColor="gray.400"
      placement="left"
      padding="0.5rem"
      label={
        <>
          <span style={changedTextStyle}>&quot;{cellData}&quot;</span> &rarr; &quot;{schemaFix}
          &quot;
        </>
      }
    >
      <Flex align="center" cursor="pointer">
        <Text
          style={{
            ...changedTextStyle,
            ...normalStyle,
          }}
        >
          &quot;{cellData}&quot;
        </Text>
        &rarr;
        <Text style={normalStyle} textOverflow="ellipsis">
          &quot;{schemaFix}&quot;
        </Text>
      </Flex>
    </Tooltip>
  )
}

export default CellDisplay
